import React from "react";
// import Deliverynote from "./Deliverynote";
import { useLocation } from 'react-router-dom';
import Header from "../../../../Components/Header";
import Asnform  from "./Create";
import { Helmet } from "react-helmet";

const AsnView = () => {
  const location = useLocation();
  const { asn_id } = location.state || {};

  return (
		<div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
			<Helmet>
				<title>View ASN</title>
			</Helmet>
			<Header />
			<div
				className="container-fluid maindiv d-flex flex-column "
				style={{ flexGrow: "1" }}
			>
				<Asnform asn_id={asn_id} />
			</div>
		</div>
	);
};

export default AsnView;
